<template>
  <div :class="'md-layout'">
    <div :class="'md-layout-item md-size-100'">
      <md-field>
        <label v-bind:style="answered ? '' : 'color: #ef4225 !important;'">{{
          question.text
        }}</label>
        <span
          :class="'md-prefix'"
          v-bind:style="answered ? '' : 'color: #ef4225 !important;'"
        >
          {{ prefixesMap[question.type] }}
        </span>
        <md-input
          v-if="question.type === 5"
          v-currency="currencyOptions"
          v-model="field"
          :disabled="isDisabled"
          @blur.prevent="send"
        />
        <md-input
          v-if="question.type === 3"
          v-mask="'#####'"
          v-model="field"
          :disabled="isDisabled"
          :maxlength="question.maxlength"
          @blur.prevent="send"
        />
        <span
          :class="'md-suffix'"
          v-bind:style="answered ? '' : 'color: #ef4225 !important;'"
        >
          {{ suffixesMap[question.type] }}
        </span>
        <slide-y-down-transition v-if="false">
          <md-icon :class="'error'">close</md-icon>
        </slide-y-down-transition>
      </md-field>
    </div>
    <div :class="'md-layout-item md-size-100'">
      <md-field>
        <label>Observation</label>
        <md-input
          type="text"
          v-model="observation"
          :disabled="isDisabled"
          :maxlength="100"
          @blur.prevent="send"
        />
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    answer: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    answered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      prefixesMap: {
        5: "",
      },
      suffixesMap: {
        3: "in hours",
      },
      currencyOptions: {
        currency: "BRL",
        locale: "pt-BR",
        precision: 2,
        "allow-negative": false,
        autoDecimalMode: true,
      },
      field: "",
      observation: "",
    };
  },
  methods: {
    send() {
      const id = this.$route.params.id;
      const data = this.getAnswer();

      // Permite enviar respostas vazias para limpar a resposta no servidor
      this.$api.request
        .post(`reviews/${id}/answers`, data)
        .then((response) => {
          this.$emit("post-sent", {
            question: this.question.id || response.data[0]["question_id"],
            answerData: data.answers[0], // Incluir os dados da resposta atualizada
          });
        })
        .catch(() => {
          this.$toast.warning("Please, try again.", "");
        });
    },
    getAnswer() {
      return {
        section: this.getSection(),
        type: this.question.type,
        answers: [
          {
            question_id: this.question.id,
            answer: this.field,
            text: this.observation,
          },
        ],
      };
    },
    getSection() {
      switch (this.$parent.mdLabel) {
        case "Engagement Leader":
          return "engagement_leader";
        case "Manager":
          return "manager";
        default:
          return "reviewer";
      }
    },
  },
  created() {
    this.field = this.answer.answer;
    this.observation = this.answer.text;
  },
};
</script>
